let splitLineColor = 'rgba(255, 255, 255, 0.1)'

export let yAxisSplitLine = {
  lineStyle: {
    color: splitLineColor
  }
}

export function LegendTextStyle ({ v }) {
  return {
    itemHeight: v.fontSizeRem(0.55),
    textStyle: {
      color: 'rgba(255, 255, 255, 0.8)',
      height: v.fontSizeRem(0.45),
      rich: {
        a: {
          verticalAlign: 'middle'
        }
      }
    }
  }
}
